<div class="col-auto pagination-container">
  <button
    class="btn btn-falcon-default btn-sm me-2"
    type="button"
    [class.disabled]="!havePrevPageNum()"
    aria-label="Prev"
    data-bs-original-title="Prev"
    (click)="navigateToPrev()"
  >
    <span class="fas fa-chevron-left"></span>
  </button>
  <button
    *ngFor="let item of paginationItems()"
    class="btn btn-falcon-default btn-sm me-2"
    [class.text-primary]="item.isCurrent"
    (click)="navigateToPage(item)"
  >
    {{ item.display }}
  </button>
  <button
    class="btn btn-falcon-default btn-sm me-2"
    type="button"
    [class.disabled]="!haveNextPageNum()"
    aria-label="Next"
    data-bs-original-title="Next"
    (click)="navigateToNext()"
  >
    <span class="fas fa-chevron-right"></span>
  </button>
</div>
